/**
 * Financial Periods Management Page
 * Admin page for managing financial periods
 */

import React from 'react';
import { AdminRoute } from '../../components/auth/AdminRoute';
import FinancialPeriods from '../../components/financial/FinancialPeriods';

const FinancialPeriodsPage = () => {
  return (
    <AdminRoute>
      <FinancialPeriods />
    </AdminRoute>
  );
};

export default FinancialPeriodsPage;
